import { createAction, createReducer } from '@reduxjs/toolkit'
import { apiCallBegan } from 'store/apiCalls'

// ACTIONS
const yearlyScorePanelRequested = createAction('yearlyScorePanel/requested')
const yearlyScorePanelReceived = createAction('yearlyScorePanel/received')
const yearlyScorePanelRequestFailed = createAction('yearlyScorePanel/requestFailed')

// REDUCER
export const initialState = {
  data: null,
  loading: false,
  error: false
}

const yearlyScorePanelReducer = createReducer(initialState, {
  [yearlyScorePanelRequested.type]: (state) => {
    state.loading = true
    state.error = false
  },
  [yearlyScorePanelReceived.type]: (state, action) => {
    state.loading = false
    state.data = action.payload
  },
  [yearlyScorePanelRequestFailed.type]: (state) => {
    state.loading = false
    state.error = true
  }
})

// THUNK
export const fetchYearlyScorePanel = (gameId) =>
  apiCallBegan({
    url: `games/${gameId}/yearly_score_panel`,
    method: 'get',
    onStart: yearlyScorePanelRequested.type,
    onSuccess: yearlyScorePanelReceived.type,
    onError: yearlyScorePanelRequestFailed.type
  })

// SELECTOR
export const selectYearlyScorePanel = (state) => state.yearlyScorePanel

export default yearlyScorePanelReducer
